import { Github } from "lucide-react"
import "../styles/SourceCode.css"

const SourceCode = () => {

  return (
    <div className="source-container">
      <h1 className="section-title">Source Code</h1>

      <div className="github-profile card">
        <div className="profile-header">
          <Github className="github-icon" />
          <h2 className="profile-title">GitHub Profile</h2>
        </div>
        <p className="profile-description">
          Check out my open source contributions and personal projects on GitHub. I believe in the power of open source
          and regularly contribute to the community.
        </p>
        <a href="https://github.com/yousefbh1" target="_blank" rel="noopener noreferrer" className="button button-primary">
          <Github size={16} />
          View GitHub Profile
        </a>
      </div>

      <div>
        <h2 className="section-title">
          Live Sand Demo
        </h2>
        <div className="simulation-container">
          <iframe
            src="sand-sim/index.html"
            width="600px"
            height="500px"
            style={{
              border: "1px solid #444",
              borderRadius: "4px"
            }}
            title="Sand Simulation"
          />
          <div className="simulation-text">
            <p style={{ marginTop: "12px" }}>
              Feel free to play around with the simulation! You can click and drag to create sand particles, and watch as they
              fall and interact with each other. The simulation is designed to be interactive and responsive, so you can
              experiment with different configurations and see how the particles behave.
            </p>
            <p style={{ marginTop: "12px" }}>
              Press 'R' or 'Space' to reset!
            </p>
            <p style={{ marginTop: "12px" }}>
              The code for this simulation is available on my GitHub profile. Feel free to check it out and explore the
              code!
            </p>
            <a href="https://github.com/yousefbh1" target="_blank" rel="noopener noreferrer" className="button button-primary"
              style={{ marginTop: "12px" }}>
              <Github size={16} />
              View Code
            </a>
          </div>
        </div>
      </div>

      <div className="terminal-section card">
        <div className="terminal-header">
          <div className="terminal-buttons">
            <span className="terminal-button close"></span>
            <span className="terminal-button minimize"></span>
            <span className="terminal-button maximize"></span>
          </div>
          <div className="terminal-title">yousef@portfolio ~ </div>
        </div>
        <div className="terminal-body">
          <div className="terminal-line">
            <span className="terminal-prompt">$ </span>
            <span className="terminal-command">git clone https://github.com/yousefbh1/portfolio-website-template.git</span>
          </div>
          <div className="terminal-output">
            Cloning into 'portfolio-website'... remote: Enumerating objects: 125, done. remote: Counting objects: 100%
            (125/125), done. remote: Compressing objects: 100% (80/80), done. remote: Total 125 (delta 40), reused 120
            (delta 35), pack-reused 0 Receiving objects: 100% (125/125), 2.5 MiB | 4.2 MiB/s, done. Resolving deltas:
            100% (40/40), done.
          </div>
          <div className="terminal-line">
            <span className="terminal-prompt">$ </span>
            <span className="terminal-command">cd portfolio-website</span>
          </div>
          <div className="terminal-line">
            <span className="terminal-prompt">$ </span>
            <span className="terminal-command">npm install</span>
          </div>
          <div className="terminal-output">
            added 1250 packages, and audited 1251 packages in 25s 150 packages are looking for funding run `npm fund`
            for details found 0 vulnerabilities
          </div>
          <div className="terminal-line">
            <span className="terminal-prompt">$ </span>
            <span className="terminal-command">npm start</span>
          </div>
          <div className="terminal-output">
            Compiled successfully! You can now view portfolio-website in the browser. Local: http://localhost:3000 On
            Your Network: http://192.168.1.5:3000 Note that the development build is not optimized. To create a
            production build, use npm run build.
          </div>
          <div className="terminal-line">
            <span className="terminal-prompt">$ </span>
            <span className="terminal-cursor"></span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SourceCode
